<template>
    <div class="table-container">
        <div class="table-wrapper">
            <table class="table">
                <thead>
                    <tr>
                        <th v-for="(thead, h) in tableItem.thead" :key="thead">{{ tableItem.thead[h] }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(tr, i) in tableItem.tbody" :key="i">
                        <td v-for="(td, i) in tr" :key="i">
                            <template v-if="typeof td !== 'object'">
                                {{ td }}
                            </template>
                            <!-- 파일 다운로드일 때 버튼 표시 -->
                            <template v-else>
                                
                                <a v-if="td.download" class="btn" href="#" onclick="event.preventDefault()">
                                    {{ td.download }}
                                    <i class="arrow-down-rounded"></i>
                                </a>
                            </template>
                        </td>

                        <th v-for="(thead, h) in tableItem[0].thead" :key="thead">{{ tableItem[0].thead[h] }}</th>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 페이지네이션 -->
        <!-- <pagination-component v-model="page" :count="pageCount" @input="search"></pagination-component> -->    
    </div>
</template>

<script>
import PaginationComponent from "@/components/client/control/pagination-component.vue";
export default {
    components: {
        PaginationComponent,
    },
    props: {
        tableItem: { default(){ return []; } },
    },
    data() {
        return{
        }
    },
    methods: {
        
    }
};
</script>
<style lang="scss" scoped>
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";

.table-container{
    .table{
        table-layout: fixed; border-collapse: collapse; width: 100%;
        line-height: 1.6; text-align: center; font-size: 16px; color: #666666;
        border-top: 1px solid $color-primary;

        th { padding: 16px 10px; color: $color-default; font-weight: 400; background-color: $color-primary-background; }
        td { padding: 16px 10px; border-bottom: 1px solid $border; }
    }
}
</style>